export default __webpack_public_path__ + "static/media/maintenance2.dcf92ec1.webp";